import { FETCHURI } from '../const/fetchuri';

const fetchFrameworkApiInstance = async (param: any, endPoint: string) => {

    return new Promise((onSucess, onFailure) => {
        fetch(FETCHURI.PostExecuteRequest, {
            method: 'post',
            headers:
            {
                'Api-Type': "Framework",
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                Param: param,
                Endpoint: endPoint
            })
        }).then(async (response) => await response.json())
            .then(async (responseJson) => {
                onSucess(responseJson.result);
            })
            .catch((error) => {
                onFailure(error);
            });
    });
}

const getFrameworkApiInstance = async (endPoint: string) => {

    const encodedValue = encodeURIComponent(endPoint);
    let urlFramework = FETCHURI.GetRequestAsync + encodedValue;
    return ExecuteFrameworkApiRequest('get', urlFramework, '');

}

const postFrameworkApiInstance = async (endPoint: string, data: any) => {
    let urlFramework = FETCHURI.PostExecuteRequest;
    return ExecuteFrameworkApiRequest('post', urlFramework, data, endPoint);
}

const getFrameworkApiNoAuthInstance = async (endPoint: string) => {
    const encodedValue = encodeURIComponent(endPoint);
    let urlFramework = FETCHURI.GetExecuteRequestNoAuth + encodedValue;
    return ExecuteFrameworkApiRequest('get', urlFramework, '');
}

const getBingMapUrlNoAuthInstance = async (endPoint: string) => {
    const encodedValue = encodeURIComponent(endPoint);
    let bingMapUrl = FETCHURI.GetBingMapUrlNoAuthInstance + encodedValue;
    return ExecuteBingMapUrlRequest(bingMapUrl);
}

const postFrameworkApiNoAuthInstance = async (endPoint: string, data: any) => {
    let urlFramework = FETCHURI.PostExecuteRequestNoAuth;
    return ExecuteFrameworkApiRequest('post', urlFramework, data, endPoint);
}


const getFromBlob = async (utype: string, isTranslate: string) => {

    const encodedValue = encodeURIComponent(utype);
    const transValue = encodeURIComponent(isTranslate);
    let urlFramework = FETCHURI.GetLinkBlobFile.replace("{utype}", encodedValue).replace("{isTranslate}", transValue);

    return ExecuteFrameworkApiRequest('get', urlFramework, '');

}

const ExecuteFrameworkApiRequest = async (method: any, url: any, params: any, endPoint?: any) => {
    type FrameworkOptions = {
        method: string;
        headers: {};
        body?: string;
    };
    const fetchFrameworkOptions: FrameworkOptions = {
        method: method,
        headers:
        {
            'Api-Type': "Framework",
            'Content-Type': 'application/json'
        }
    };
    if (method.toString().toLowerCase() != 'get') {
        fetchFrameworkOptions.body = JSON.stringify({
            Param: params,
            Endpoint: endPoint
        })
    }
    return await new Promise((onSucess, onFailure) => {
         fetch(url, fetchFrameworkOptions).then(async (response) => await response.json())
            .then(async (responseJson) => {
                if (responseJson?.result != undefined || responseJson?.result != null) {
                    (responseJson?.result == '') ? onSucess(responseJson?.result) : onSucess(JSON.parse(responseJson?.result));
                }
                else {
                    (responseJson?.statusCode != undefined && responseJson?.statusCode != null && responseJson?.statusCode !== 200) ? onFailure(responseJson.reasonPhrase) : onSucess(responseJson);
                }                
            })
            .catch((error) => {
                onFailure(error);
            });
    });
}

const ExecuteBingMapUrlRequest = async (url: any) => {  
    return await new Promise((onSucess, onFailure) => {
         fetch(url).then(async (response) => await response.json())
            .then(async (responseJson) => {
                if (responseJson?.result != undefined || responseJson?.result != null) {
                    (responseJson?.result == '') ? onSucess(responseJson?.result) : onSucess(JSON.parse(responseJson?.result));
                }
                else {
                    (responseJson?.statusCode != undefined && responseJson?.statusCode != null && responseJson?.statusCode !== 200) ? onFailure(responseJson.reasonPhrase) : onSucess(responseJson);
                }                
            })
            .catch((error) => {
                onFailure(error);
            });
    });
}

export { fetchFrameworkApiInstance, getFrameworkApiInstance, getFromBlob, postFrameworkApiInstance,
    postFrameworkApiNoAuthInstance, getFrameworkApiNoAuthInstance, getBingMapUrlNoAuthInstance
 }


